import {Layout} from '@di-nxt/components';
import React from 'react';

export const Screen: React.FC = ({children}) => {
  return (
    <Layout backgroundColor="background_mono_primary" absolute vertical>
      {children}
    </Layout>
  );
};
